import {useRouter} from 'next/router'
import dynamic from 'next/dynamic'
import React, {useEffect, useState} from "react";
import HistoryChart from "../../components/stock/HistoryChart";
import axios from "../../components/plugins/axios";
import {callIranMarketStockSummaryAPI, fetchStockSummary} from "../../util/APIUtils";
import {makeStockHelmet} from "../../util/SEOUtil";
import StockSummary from "../../components/summary/StockSummary";
import Box from "../../components/box/Box";
import {parseIranMarketApiResponse} from "../../util/DominantUtil";

const HistoryChartDynamic = dynamic(() =>
        import('../../components/stock/HistoryChart'),
    {ssr: false})

const TVChartContainer = dynamic(
    () =>
        import('../../components/tradingView/TVChartContainer').then(mod => mod.default),
    {ssr: false},
);

export default function Stock({stockSummary}) {
    const market = "طلا"

    console.log(stockSummary)
    return (
        <Box disableHeader={true} loaded={true}
             leftBoxClassName={'w-100 bg-white'}
             height={1150}>
            {stockSummary && makeStockHelmet({market: market, assetType: market, faN: stockSummary.s})}
            <div className="stock-box p-20px">
                <div className="row">
                    <div className="col-xl-5 col-lg-5 col-md col-sm">
                        <StockSummary data={stockSummary}/>
                    </div>
                    <div className="col-xl-7 col-lg-7 col-md col-sm">
                        <HistoryChartDynamic symbol={stockSummary.s}/>
                    </div>
                </div>
                <TVChartContainer symbol={stockSummary.s} has_no_volume={true}/>
            </div>
        </Box>
    );
}

export async function getServerSideProps(context) {
    const {stock} = context.query;
    const response = await fetchStockSummary("IRMET:" + stock);

    if (response.length === 0) {
        return {
            notFound: true,
        };
    }

    const stockSummary = parseIranMarketApiResponse(response)[0];

    return {
        props: {
            stockSummary
        },
    };
}
